<template>
  <ComponentCard title="Qur'an verse" icon="solar:book-2-linear">
    <template #actions>
      <form v-if="!readOnly" class="ml-auto flex items-center gap-1" @submit.prevent="fill">
        <input v-model="lookup" type="text" placeholder="2:255" aria-label="Surah and verse" class="w-20 rounded-lg border border-[#1c4848]/10 px-2 py-1 text-xs text-[#1c4848] outline-none focus:border-[#1c4848]/30">
        <button type="submit" class="rounded-lg bg-[#1c4848] px-2.5 py-1 text-[11px] font-bold text-white disabled:opacity-50" :disabled="busy || !lookup.trim()">{{ busy ? '…' : 'Fill' }}</button>
      </form>
    </template>
    <p v-if="error" role="alert" class="text-xs text-red-700">{{ error }}</p>
    <BlockField :model-value="attrs.arabic" arabic placeholder="الآية" :read-only="readOnly" input-class="text-[#1c4848]" @update:model-value="set({ arabic: $event })" />
    <BlockField :model-value="attrs.translation" placeholder="Translation" :read-only="readOnly" input-class="text-[15px] leading-relaxed text-[#1c4848]" @update:model-value="set({ translation: $event })" />
    <BlockField :model-value="attrs.reference" placeholder="Reference, like Al-Baqarah 2:255" :read-only="readOnly" input-class="text-xs font-semibold text-[#a0833c]" @update:model-value="set({ reference: $event })" />
  </ComponentCard>
</template>

<script setup>
import { ref } from 'vue';
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });

const lookup = ref('');
const busy = ref(false);
const error = ref('');

async function fill() {
  busy.value = true;
  error.value = '';
  try {
    const [ayah] = await props.context.search({ q: lookup.value.trim(), kind: 'ayah', limit: 1 });
    if (ayah) {
      props.set({ arabic: ayah.arabic ?? '', translation: ayah.text ?? '', reference: ayah.reference ?? ayah.title ?? '' });
      lookup.value = '';
    } else {
      error.value = `No verse ${lookup.value} in this book's language.`;
    }
  } catch {
    error.value = 'The verse could not be loaded.';
  } finally {
    busy.value = false;
  }
}
</script>
